/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CdkDropList } from '@angular/cdk/drag-drop';
import { Directive } from '@angular/core';
import { noop } from 'lodash';

/**
 * This directive implements monkey patch to disable sorting in drop list while dragging.
 * This monkey patch MUST BE REMOVED as soon as the following feature will be implemented
 * https://github.com/angular/material2/issues/14838
 */
@Directive({
  standalone: false,
  selector: '[ghMonkeyDropListSortingDisabled]',
})
export class MonkeyDropListSortingDisabledDirective {
  constructor(private dropList: CdkDropList) {
    // preventing sorting in CdkDropList
    // (solution was taken from this PR https://github.com/angular/material2/pull/15064)
    dropList._dropListRef._sortItem = noop;
  }
}
